<template>
	<div style="width: 400px; height: 700px;">
		<!-- 高德地图组件 -->
		<div id="container"></div>


	</div>

</template>

<script>
	// 导入 AMapLoader
	import AMapLoader from '@amap/amap-jsapi-loader';
	import Geocoder from '@amap/amap-jsapi-loader';
	import placeSearch from '@amap/amap-jsapi-loader';
	import axios from 'axios';
	import {
		Dialog
	} from 'element-ui';
	import {
		Toast
	} from 'vant';

	export default {
		data() {
			return {
				map: null, // 定义 map 属性
				marker: null,
				circle01: null,
				circle02: null,
				myRadius: 200, //半径的大小
				address: "", //当前的地理位置
				lat: "",
				lng: "",
				myToyRole: "",
				isShowLog: 0, //是否展示打印日志 0不显示 1显示
				isWzMap: 0, //是否跳转到维智地图 0不跳转 1跳转
			}
		},
		mounted() {
			window.receiveData = this.receiveData; // 将 JavaScript 函数暴露给 Android
			window.initGaudMap = this.initGaudMap; // 将 JavaScript 函数暴露给 Android
			window.setMyRadius = this.setMyRadius; // 将 JavaScript 函数暴露给 Android
			window.getLocation = this.getLocation; // 将 JavaScript 函数暴露给 Android
			window.toLocation = this.toLocation; // 将 JavaScript 函数暴露给 Android
			window.autoInput = this.autoInput; // 将 JavaScript 函数暴露给 Android
			window.setPOI = this.setPOI; // 将 JavaScript 函数暴露给 Android
			window.setIsShowLog = this.setIsShowLog; // 将 JavaScript 函数暴露给 Android
			window.getIsWzMap = this.getIsWzMap; // 将 JavaScript 函数暴露给 Android

			window._AMapSecurityConfig = { // 设置高德地图安全配置
					securityJsCode: "6b0524f2161d0e939ed4c23ae125e701",//自己的安全密钥
					//securityJsCode: "c42779665120dea2b3e1a4bfcb43f4d7", //郭总的安全密钥
				},
				setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上
					// 加载高德地图JS API
					AMapLoader.load({
							key: "49a44fd6a707f403a62b64084d260192", //申请好的Web端开发者key，调用 load 时必填 自己个人认证的
							//key: "e336bc1b092b8251e0f7b25286107e06", //郭总注册的
							version: "2.0", //指定要加载的 JS API 的版本，缺省时默认为 1.4.15
						})
						.then((AMap) => {
							// JS API 加载完成后获取AMap对象
							// this.map = new AMap.Map("container");
						})
						.catch((e) => {
							console.error("加载错误提示:" + e); //加载错误提示
						});
				}, 500); // 等待500毫秒
		},
		methods: {
			//------------------------------------------------------APP与h5交互
			receiveData(data) {
				alert("接收APP的数据:" + data);
			},
			setIsShowLog(data) {
				this.isShowLog = data;
			},
			setMyRadius(data) {
				this.myRadius = data; //设置半径的大小
			},
			getIsWzMap() { //看是否需要跳转到维智地图
				window.Android.isToWzMapH5Activity(this.isWzMap);
			},
			getLocation() { //获取当前的位置信息
				const requestData = {}; //传递的参数
				requestData.address = this.address;
				requestData.lat = this.lat;
				requestData.lng = this.lng;
				requestData.myRadius = this.myRadius;
				//alert("requestData:" + JSON.stringify(requestData));

				window.Android.getLocationAndroid(JSON.stringify(requestData));
			},
			initGaudMap(data) { //通过APP传递过来的数据 初始化地理位置

				try {

					if (this.isShowLog == 1) alert("初始化地理位置 接收到的数据:" + data);

					var str = data.slice(1, -1);
					var locationArray = str.split(","); // 使用逗号分隔字符串并拆分成数组

					this.address = locationArray[2];
					this.lat = locationArray[0];
					this.lng = locationArray[1];

					if (this.isShowLog == 1) alert("初始化地理位置  解析数据完成");

					setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上

						if (this.isShowLog == 1) alert("初始化地理位置  开始渲染");

						this.map = new AMap.Map('container', {
							resizeEnable: true,
							zoom: 17, //级别
							center: [locationArray[1], locationArray[0]], //中心点坐标
							viewMode: '3D' //使用3D视图
						});

						this.marker = new AMap.Marker({ // 构造点标记
							icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
							position: [locationArray[1], locationArray[0]]
						});

						this.circle01 = new AMap.Circle({ // 构造矢量圆形
							center: new AMap.LngLat(locationArray[1], locationArray[0]), // 圆心位置
							radius: this.myRadius, //半径
							strokeColor: "#ee2200", //线颜色
							strokeOpacity: 0.35, //线透明度
							strokeWeight: 3, //线粗细度
							fillColor: "#ee2200", //填充颜色
							fillOpacity: 0.35 //填充透明度
						});

						this.circle02 = new AMap.Circle({ // 构造矢量圆形
							center: new AMap.LngLat(locationArray[1], locationArray[0]), // 圆心位置
							radius: this.myRadius * 2, //半径
							strokeColor: "#ee2200", //线颜色
							strokeOpacity: 0.25, //线透明度
							strokeWeight: 3, //线粗细度
							fillColor: "#ee2200", //填充颜色
							fillOpacity: 0.25 //填充透明度
						});

						if (this.isShowLog == 1) alert("初始化地理位置  开始添加图层");

						this.map.add(this.marker);
						this.map.add(this.circle01);
						this.map.add(this.circle02);
						this.map.setFitView();

						this.map.on('click', this.showInfoClick); //地图的单击事件

					}, 500); // 等待500毫秒
				} catch (error) {
					alert("初始化地理位置 error: " + error.message);
				}

			},
			toLocation(data) { //跳转到开锁定位的位置

				try {
					var str = data.slice(1, -1);
					var locationArray = str.split(","); // 使用逗号分隔字符串并拆分成数组

					this.lat = locationArray[0];
					this.lng = locationArray[1];
					this.myRadius = locationArray[3];
					this.myToyRole = locationArray[4];

					setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上

						this.map = new AMap.Map('container', {
							resizeEnable: true,
							zoom: locationArray[2], //级别
							center: [locationArray[1], locationArray[0]], //中心点坐标
							viewMode: '3D' //使用3D视图
						});

						this.marker = new AMap.Marker({ // 构造点标记
							icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
							position: [locationArray[1], locationArray[0]]
						});

						this.circle01 = new AMap.Circle({ // 构造矢量圆形
							center: new AMap.LngLat(locationArray[1], locationArray[0]), // 圆心位置
							radius: locationArray[3], //半径
							strokeColor: "#ee2200", //线颜色
							strokeOpacity: 0.35, //线透明度
							strokeWeight: 3, //线粗细度
							fillColor: "#ee2200", //填充颜色
							fillOpacity: 0.35 //填充透明度
						});

						this.circle02 = new AMap.Circle({ // 构造矢量圆形
							center: new AMap.LngLat(locationArray[1], locationArray[0]), // 圆心位置
							radius: locationArray[3] * 2, //半径
							strokeColor: "#ee2200", //线颜色
							strokeOpacity: 0.25, //线透明度
							strokeWeight: 3, //线粗细度
							fillColor: "#ee2200", //填充颜色
							fillOpacity: 0.25 //填充透明度
						});

						this.map.add(this.marker);
						this.map.add(this.circle01);
						this.map.add(this.circle02);
						this.map.setFitView();

						if (this.myToyRole == 1)
							this.map.on('click', this.showInfoClick); //地图的单击事件

					}, 500); // 等待500毫秒
				} catch (error) {
					alert("跳转到开锁定位的位置 error: " + error.message);
				}
			},
			setPOI(data) { //选中了POI
				this.map.remove(this.marker);
				this.map.remove(this.circle01);
				this.map.remove(this.circle02);
				this.map.setFitView();

				var str = data.slice(1, -1);
				var locationArray = str.split(","); // 使用逗号分隔字符串并拆分成数组

				this.address = locationArray[4];
				this.lat = locationArray[0];
				this.lng = locationArray[1];
				this.myRadius = locationArray[3];

				setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上

					this.map = new AMap.Map('container', {
						resizeEnable: true,
						zoom: locationArray[2], //级别
						center: [locationArray[1], locationArray[0]], //中心点坐标
						viewMode: '3D' //使用3D视图
					});

					this.marker = new AMap.Marker({ // 构造点标记
						icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
						position: [locationArray[1], locationArray[0]]
					});

					this.circle01 = new AMap.Circle({ // 构造矢量圆形
						center: new AMap.LngLat(locationArray[1], locationArray[0]), // 圆心位置
						radius: locationArray[3], //半径
						strokeColor: "#ee2200", //线颜色
						strokeOpacity: 0.35, //线透明度
						strokeWeight: 3, //线粗细度
						fillColor: "#ee2200", //填充颜色
						fillOpacity: 0.35 //填充透明度
					});

					this.circle02 = new AMap.Circle({ // 构造矢量圆形
						center: new AMap.LngLat(locationArray[1], locationArray[0]), // 圆心位置
						radius: locationArray[3] * 2, //半径
						strokeColor: "#ee2200", //线颜色
						strokeOpacity: 0.25, //线透明度
						strokeWeight: 3, //线粗细度
						fillColor: "#ee2200", //填充颜色
						fillOpacity: 0.25 //填充透明度
					});

					this.map.add(this.marker);
					this.map.add(this.circle01);
					this.map.add(this.circle02);
					this.map.setFitView();

					this.map.on('click', this.showInfoClick); //地图的单击事件

				}, 500); // 等待500毫秒
			},
			autoInput(data) { //POI搜索
				//alert("POI:" + data);
				try {
					AMap.plugin('AMap.PlaceSearch', function() {
						var autoOptions = {
							city: '全国'
						}
						var placeSearch = new AMap.PlaceSearch(autoOptions);
						placeSearch.search(data, function(status, result) { // 搜索成功时，result即是对应的匹配数据
							if (status === 'complete' && result.info === "OK") {
								//alert("result:" + result.poiList.pois[0].name);
								window.Android.getAutoInputAndroid(JSON.stringify(result));
								//alert("result:" + JSON.stringify(result));
							}
						})
					});
				} catch (error) {
					alert("Error occurred: " + error.message);
				}
			},
			//------------------------------------------------------------------------------------------------------------------------------------------------------------------
			showInfoClick(e) { //单击地图
				this.map.remove(this.marker);
				this.map.remove(this.circle01);
				this.map.remove(this.circle02);
				this.map.setFitView();

				this.marker = new AMap.Marker({ // 构造点标记
					icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
					position: [e.lnglat.getLng(), e.lnglat.getLat()]
				});

				this.circle01 = new AMap.Circle({ // 构造矢量圆形
					center: new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()), // 圆心位置
					radius: this.myRadius,
					strokeColor: "#ee2200", //线颜色
					strokeOpacity: 0.35, //线透明度
					strokeWeight: 3, //线粗细度
					fillColor: "#ee2200", //填充颜色
					fillOpacity: 0.35 //填充透明度
				});

				this.circle02 = new AMap.Circle({ // 构造矢量圆形
					center: new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()), // 圆心位置
					radius: this.myRadius * 2,
					strokeColor: "#ee2200", //线颜色
					strokeOpacity: 0.25, //线透明度
					strokeWeight: 3, //线粗细度
					fillColor: "#ee2200", //填充颜色
					fillOpacity: 0.25 //填充透明度
				});

				this.map.add(this.marker);
				this.map.add(this.circle01);
				this.map.add(this.circle02);
				this.map.setFitView();

				const lng = e.lnglat.getLng();
				const lat = e.lnglat.getLat();
				const lnglat = lng + ',' + lat;

				this.lat = lat;
				this.lng = lng;

				try {
					AMap.plugin('AMap.Geocoder', () => { // 使用箭头函数
						var geocoder = new AMap.Geocoder({
							radius: 1000,
							extensions: "all"
						});
						geocoder.getAddress(new AMap.LngLat(lng, lat), (status, result) => {
							if (status === 'complete' && result.regeocode) {
								//alert(result.regeocode.formattedAddress);
								this.address = result.regeocode.formattedAddress + "";
								//alert("this.address :" + this.address);
							} else {
								alert("根据经纬度查询地址失败");
							}
						});
					});
				} catch (error) {
					alert("Error occurred: " + error.message);
				}

			},

			//...
		},
		//...
	};
</script>

<style scoped>
	html,
	body,
	#container {
		width: 100%;
		height: 100%;
		display: flex;
	}
</style>